import styled from 'styled-components';

const SapBaseAd = styled.div`
    background-color: ${({ theme }) => theme.Surface.primary};
    position: relative;
    overflow: hidden;
    text-align: center;
    z-index: 99;
`;

export const FullSizeAd = styled(SapBaseAd)`
    background: inherit;
    margin-bottom: 24px;
`;

export const MobileSapHeaderAd = styled(SapBaseAd)`
    padding-top: 24px;
    z-index: 1;
`;
